import { FileType, FileTypeCategory, ModulePropertyOptionItem, UiControlType } from '@ca/core/models';
import { OptionItem } from 'src/app/core/models/option-item.model';

export const moduleDataTypePrefix = 'type:';
export const moduleWidgetTypePrefix = 'widget:';

export const moduleDataTypes: Array<ModulePropertyOptionItem> = [
    { label: 'Number', value: 'number', widgets: ['slider', 'textbox'] },
    { label: 'Integer', value: 'integer', widgets: ['slider', 'textbox'] },
    /*
     *   Range Slider commented out, because of lacking backend implementation
     *  (Will be done with 316338)
     */
    /*{ label: 'Range', value: 'range', widgets: ['slider_range'], inputOnly: true },*/
    { label: 'String', value: 'string', widgets: ['textbox'] },
    { label: 'File', value: 'file', widgets: ['none'] },
    { label: 'List of files', value: 'list[file]', widgets: ['none'] },
    { label: 'Binary Choice', labelOutput: 'Boolean', value: 'choice_binary', widgets: ['checkbox'], inputOnly: true },
    { label: 'Single Choice', value: 'choice_single', widgets: ['radiobuttongroup', 'dropdown'], inputOnly: true },
];

export const moduleControlTypes: Array<OptionItem<UiControlType>> = [
    { label: 'Slider', value: 'slider' },
    { label: 'Textbox', value: 'textbox' },
    { label: 'Range Slider', value: 'slider_range' },
    { label: 'Checkbox', value: 'checkbox' },
    { label: 'Radio-Button Group', value: 'radiobuttongroup' },
    { label: 'Dropdown', value: 'dropdown' },
    { label: 'File Dialog', value: 'file_dialog' },
    { label: 'No UI', value: 'none' },
];

export const fileTypeCategories: FileTypeCategory[] = ['image', 'data', 'other'];

export const moduleFileTypes: FileType[] = [
    { type: 'OME-TIFF', extensions: ['ome.tiff', 'ome.tif'], format: 'ome-tiff', category: 'image' },
    { type: 'CZI', extensions: ['czi'], format: 'czi', category: 'image' },
    { type: 'TIFF', extensions: ['tiff', 'tif'], format: 'tiff', category: 'image' },
    { type: 'PNG', extensions: ['png'], format: 'png', category: 'image' },
    { type: 'JFIF/JPEG', extensions: ['jpg', 'jpeg', 'jpe', 'jfif'], format: 'jpeg', category: 'image' },
    { type: 'CSV', extensions: ['csv'], format: 'csv', category: 'data' },
    // { type: "PDF", extensions: ["pdf"], format: "pdf", category: "data" },
    { type: 'HTML', extensions: ['htm', 'html'], format: 'html', category: 'other' },
    { type: 'XML', extensions: ['xml'], format: 'xml', category: 'data' },
];
